import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {

  public expanded = false;

  public links = [
    { title: 'Home', link: '' },
    { title: 'About', link: 'about' },
    { title: 'Ice Machines', link: 'ice-machines' },
    { title: 'Commercial Refrigeration', link: 'commercial-refrigeration' },
    { title: 'Customers', link: 'customers' },
    { title: 'Contact', link: 'contact' }
  ];

  constructor(private router: Router) {}

  public navigate(link: string) {
    this.expanded = false;
    this.router.navigate([ link ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav/nav.component.ts